---
label: Trash
category: files-and-storage
icon: Trash2Icon
keywords: [trash, delete, restore, empty, recycle, permanent]
addedInVersion: "0.0.0"
---

# Trash

Deleted files move to the trash instead of being permanently removed.

## Deleting Items

Right-click in the file tree and choose **Delete**, or press <Kbd>Delete</Kbd>
or <Kbd>Backspace</Kbd>.

## Viewing Trash

Click the trash icon in the sidebar toolbar to open the trash dialog.

## Restoring Items

Click the restore button on any trashed item to move it back to its original
location.

## Permanent Deletion

Click the delete button on an item or **Empty Trash** to permanently remove
items. A brief undo opportunity appears before deletion is finalized.

## Auto-Empty

Configure automatic trash cleanup in [Storage Settings](/settings/storage).
